// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verticalEffect {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-y: auto;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.verticalEffect .el-radio__label {\n    font-size: 13px !important;\n}\n", ""]);
// Exports
module.exports = exports;
